import { Alert, Card, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

interface HealthResponse {
  status: string;
  database: string;
  uptimeSeconds: number;
}

export function DashboardPage() {
  const { user } = useAuth();

  const health = useQuery({
    queryKey: ['health'],
    queryFn: () => api.get<HealthResponse>('/health'),
    refetchInterval: 30_000,
  });

  return (
    <Stack gap="lg">
      <div>
        <Title order={2}>Здравствуйте, {user?.fullName}</Title>
        <Text c="dimmed" size="sm" mt={4}>
          Система в разработке. Готова основа: база данных, авторизация, расчёт сумм и НДС.
        </Text>
      </div>

      <Alert icon={<IconInfoCircle size={18} />} color="blue" variant="light">
        Следующий этап — справочники организаций, контрагентов и номенклатуры,
        затем счёт на оплату с печатной формой.
      </Alert>

      <SimpleGrid cols={{ base: 1, sm: 3 }}>
        <Card withBorder radius="md" padding="md">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            Состояние API
          </Text>
          <Group gap="xs" mt={6}>
            <Text size="xl" fw={700}>
              {health.isLoading ? '…' : health.data?.status === 'ok' ? 'Работает' : 'Ошибка'}
            </Text>
          </Group>
        </Card>

        <Card withBorder radius="md" padding="md">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            База данных
          </Text>
          <Text size="xl" fw={700} mt={6}>
            {health.isLoading
              ? '…'
              : health.data?.database === 'connected'
                ? 'Подключена'
                : 'Недоступна'}
          </Text>
        </Card>

        <Card withBorder radius="md" padding="md">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            Ваша роль
          </Text>
          <Text size="xl" fw={700} mt={6}>
            {user?.role === 'ADMIN' ? 'Администратор' : user?.role}
          </Text>
        </Card>
      </SimpleGrid>
    </Stack>
  );
}
